var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00002 2.00002C4.81592 2.00002 4.66669 2.14925 4.66669 2.33335V3.33335H11C11.9205 3.33335 12.6667 4.07955 12.6667 5.00002V11.3334H13.6667C13.8508 11.3334 14 11.1841 14 11V2.33335C14 2.14925 13.8508 2.00002 13.6667 2.00002H5.00002ZM12.6667 12.6667H13.6667C14.5872 12.6667 15.3334 11.9205 15.3334 11V2.33335C15.3334 1.41289 14.5872 0.666687 13.6667 0.666687H5.00002C4.07952 0.666687 3.33335 1.41289 3.33335 2.33335V3.33335H2.33335C1.41288 3.33335 0.666687 4.07955 0.666687 5.00002V13.6667C0.666687 14.5872 1.41288 15.3334 2.33335 15.3334H11C11.9205 15.3334 12.6667 14.5872 12.6667 13.6667V12.6667ZM2.33335 4.66669C2.14926 4.66669 2.00002 4.81593 2.00002 5.00002V13.6667C2.00002 13.8508 2.14926 14 2.33335 14H11C11.1841 14 11.3334 13.8508 11.3334 13.6667V5.00002C11.3334 4.81593 11.1841 4.66669 11 4.66669H2.33335Z",
    fill: "#7FDEFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.f2c0e84a.svg";
export { ForwardRef as ReactComponent };